import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import PaymentTypeServices from "../../../../../services/OrderingServices/PaymentTypeService";




const PaymentMethod = ({ isOpen, toggle, setSelectedPayment }) => {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null); // track selected payment

  const fetchData = async () => {
    try {
      const response = await PaymentTypeServices.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSelect = () => {
    if (selected) {
      setSelectedPayment(selected);
      toggle(); // close modal after selection
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Select Payment Method</ModalHeader>
      <ModalBody>
        <Row>
          {data?.map((item, index) => (
            <Col key={index} sm={6}>
              <Card
                onClick={() => setSelected(item)}
                className={`cursor-pointer ${selected?.id === item.id ? "border border-primary" : ""}`}
              >
                <CardBody>
                  <h6>{item?.name}</h6>
                  <h6>{item?.accountNumber}</h6>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </ModalBody>

      <ModalFooter>
        <button
          className="btn btn-success"
          onClick={handleSelect}
          disabled={!selected}
        >
          Confirm
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default PaymentMethod;

